/* eslint-disable */
import { colors } from '../../helper/constant/colors';
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import meya_logo from '../../assets/images/logo_meya.png';
import img_slide_8 from '../../assets/images/IMG_SLIDE_8.jpg';
import { THAI_PROVINCES } from '../../helper/constant';
import JobEmployerMap from './JobEmployerMap';
import JobSidebarMapWidget from './JobSidebarMapWidget';
import { formatSalary, formatShortDate, resolveMapCoords, resolveJobCategory, fetchAllPagedItems, resolveJobPosterImages, calculateDistanceKm } from './jobUtils';
import './JobSearch.css';

const CAREER_CATEGORIES = [
  { id: 'doctor', title: 'แพทย์', count: '0', icon: 'mdi-stethoscope' },
  { id: 'nurse', title: 'พยาบาล', count: '0', icon: 'mdi-heart-pulse' },
  { id: 'pharmacist', title: 'เภสัชกร', count: '0', icon: 'mdi-pill' },
  { id: 'lab', title: 'เทคนิคการแพทย์', count: '0', icon: 'mdi-microscope' },
  { id: 'dentist', title: 'ทันตแพทย์', count: '0', icon: 'mdi-tooth' },
  { id: 'physio', title: 'นักกายภาพบำบัด', count: '0', icon: 'mdi-human-handsdown' },
  { id: 'xray', title: 'รังสีเทคนิค', count: '0', icon: 'mdi-radioactive' },
  { id: 'health_officer', title: 'เจ้าหน้าที่สาธารณสุข', count: '0', icon: 'mdi-hospital-building' },
];

const JOBS_PER_PAGE = 12;

const includesSafe = (value, needle) => String(value || '').toLowerCase().includes(String(needle || '').toLowerCase());

const parseExperienceYears = (experience) => {
  const text = String(experience || '');
  if (!text.trim()) return null;
  if (text.includes('< 1') || text.includes('น้อยกว่า') || text.includes('จบใหม่')) return 0;
  const match = text.match(/(\d+(\.\d+)?)/);
  return match ? Number(match[1]) : null;
};

const matchesExperienceFilter = (experience, selectedExp) => {
  if (selectedExp === 'ทั้งหมด') return true;
  const years = parseExperienceYears(experience);
  if (years === null) return false;
  if (selectedExp === 'จบใหม่ / < 1 ปี') return years < 1;
  if (selectedExp === '1 - 3 ปี') return years >= 1 && years < 3;
  if (selectedExp === '3 - 5 ปี') return years >= 3 && years < 5;
  if (selectedExp === '5 ปีขึ้นไป') return years >= 5;
  return true;
};

const matchesCategory = (itemCategory, selected) => {
  if (selected === 'ทั้งหมด') return true;
  if (!itemCategory) return false;
  const item = resolveJobCategory(itemCategory, itemCategory) || itemCategory;
  const sel = resolveJobCategory(selected, selected) || selected;
  return item === sel || item.includes(sel) || sel.includes(item);
};

const buildCategoryCountsFromJobs = (jobs, baseCategories = CAREER_CATEGORIES) => {
  return baseCategories.map((cat) => {
    const count = (jobs || []).filter((j) => matchesCategory(j.category, cat.title)).length;
    return { ...cat, count: String(count) };
  });
};

const parseSalaryNumbers = (salaryStr) => {
  if (!salaryStr) return [];
  const nums = String(salaryStr).replace(/,/g, '').match(/\d+/g);
  return nums ? nums.map(Number) : [];
};

const matchesSalaryRange = (salaryStr, selectedRange) => {
  if (selectedRange === 'ทั้งหมด') return true;
  const nums = parseSalaryNumbers(salaryStr);
  if (!nums.length) return false;
  const value = Math.max(...nums);
  if (selectedRange === '15,000 - 30,000 บาท') return value >= 15000 && value <= 30000;
  if (selectedRange === '30,000 - 50,000 บาท') return value >= 30000 && value <= 50000;
  if (selectedRange === '50,000 - 100,000 บาท') return value >= 50000 && value <= 100000;
  if (selectedRange === '100,000+ บาท') return value >= 100000;
  return true;
};

function JobSearch({ permitdata, app_hostname, open_signin, isUserLoggedIn, setIsUserLoggedIn, regName, setRegName }) {
  const navigate = useNavigate();
  const location = useLocation();

  const [activeTab, setActiveTab] = useState('jobs'); 
  const [selectedCandidate, setSelectedCandidate] = useState(null); 
  const [searchTerm, setSearchTerm] = useState('');
  const [locationTerm, setLocationTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('ทั้งหมด');
  const [selectedExp, setSelectedExp] = useState('ทั้งหมด');
  const [selectedSalary, setSelectedSalary] = useState('ทั้งหมด');
  const [selectedStatus, setSelectedStatus] = useState('ทั้งหมด');
  const [selectedProvince, setSelectedProvince] = useState('ทั้งหมด');
  const [selectedRadius, setSelectedRadius] = useState('ทั้งหมด');
  const [userLocation, setUserLocation] = useState(null);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [sortBy, setSortBy] = useState('latest'); 
  const [jobsPage, setJobsPage] = useState(1);

  // DB States
  const [rawJobs, setRawJobs] = useState([]);
  const [rawCandidates, setRawCandidates] = useState([]);
  const [careerCategories, setCareerCategories] = useState(CAREER_CATEGORIES);
  const [loading, setLoading] = useState(false);
  const categoryFilterOptions = ['ทั้งหมด', ...careerCategories.map((c) => c.title)];

  // Modals & Toast State
  const [showMapModal, setShowMapModal] = useState(false);
  const [mapInitialCoords, setMapInitialCoords] = useState(null);
  const [showContactModal, setShowContactModal] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [showMobileFilters, setShowMobileFilters] = useState(false);
  const [candidateImgErrors, setCandidateImgErrors] = useState({});

  const handleCandidateImgError = (id) => {
    setCandidateImgErrors((prev) => ({ ...prev, [id]: true }));
  };

  const getShopToken = () => {
    try {
      const stored = sessionStorage.getItem('meya-token4');
      if (stored && stored !== 'undefined') {
        const parsed = JSON.parse(stored);
        if (parsed?.token && (parsed?.shop_id || permitdata?.shop_id)) {
          return parsed.token;
        }
      }
      if (permitdata?.token && permitdata?.shop_id) {
        return permitdata.token;
      }
    } catch (err) {
      console.error('[JobSearch] Failed to resolve shop token:', err);
    }
    return '';
  };

  const isShopLoggedIn = Boolean(
    permitdata?.shop_id ||
    permitdata?.role === 'shop' ||
    permitdata?.role === 'seller' ||
    Boolean(getShopToken())
  );

  const fetchLiveJobData = async () => {
    setLoading(true);
    try {
      const shopToken = getShopToken();
      const queryUrl = (app_hostname || '') + '/api/market/jobs/query';

      let categoriesFromApi = null;
      const allJobRows = await fetchAllPagedItems({
        pageSize: 50,
        maxPages: 40,
        request: async (payload) => {
          const jobsRes = await axios.post(queryUrl, payload);
          if (
            payload.page === 1 &&
            jobsRes.data?.data?.categories &&
            jobsRes.data.data.categories.length > 0
          ) {
            categoriesFromApi = jobsRes.data.data.categories.map((c) => ({
              id: c.category_code || String(c.category_id || c.id),
              title: c.title_th,
              count: '0',
              icon: c.icon_class || 'mdi-briefcase-outline',
            }));
          }
          return jobsRes;
        },
      });

      if (categoriesFromApi?.length) {
        setCareerCategories(categoriesFromApi);
      }

      let candidatesRes = null;
      if (isShopLoggedIn && shopToken) {
        candidatesRes = await axios
          .post(
            (app_hostname || '') + '/api/market/jobs/candidates',
            {},
            { headers: { Authorization: `Bearer ${shopToken}` } },
          )
          .catch((err) => {
            console.warn('Candidate fetching failed or unauthorized:', err?.message);
            return null;
          });
      }

      const resolveImgUrl = (url, fallback) => {
        if (!url) return fallback;
        if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:')) return url;
        return (app_hostname || '') + url;
      };

      const items = allJobRows
        .filter((j) => {
          const st = String(j.status || 'active').toLowerCase();
          return st !== 'closed' && st !== 'deleted' && st !== 'inactive';
        })
        .map((j) => {
          const coords = resolveMapCoords({
            id: j.job_id || j.id,
            lat: j.lat ?? j.latitude,
            lng: j.lng ?? j.longitude ?? j.lon,
            province: j.province,
            address: j.address,
            location: j.province,
            district: j.district,
            title: j.title,
            company: j.company_name,
          });
          const logo = resolveImgUrl(j.company_logo, meya_logo);
          const posterResolved = resolveJobPosterImages({
            jobId: j.job_id || j.id,
            posterImage: j.poster_image ? resolveImgUrl(j.poster_image, '') : '',
            galleryImages: j.gallery_images,
            logoUrl: logo,
            preferLogoWhenEmpty: true,
          });
          return {
            id: j.job_id || j.id,
            title: j.title,
            company: j.company_name,
            category: resolveJobCategory(j.title, j.category_name),
            location: coords.province || j.province,
            address: j.address || '',
            salary: formatSalary(j.salary_min, j.salary_max, j.salary_text, j.salary_negotiable),
            type: j.job_type || 'Full Time',
            posted: formatShortDate(j.created_at),
            logo,
            poster: posterResolved.hasCustomPoster ? posterResolved.cover : logo,
            lat: coords.lat,
            lng: coords.lng,
            is_featured: j.is_featured,
          };
        });
      setRawJobs(items);
      setCareerCategories((prev) => buildCategoryCountsFromJobs(items, prev?.length ? prev : CAREER_CATEGORIES));
      setJobsPage(1);

      if (candidatesRes && candidatesRes.data && candidatesRes.data.status === 'Success' && candidatesRes.data.data) {
        const cands = (candidatesRes.data.data.items || []).map(c => {
          const coords = resolveMapCoords({
            id: c.user_id || c.id,
            lat: c.lat ?? c.latitude,
            lng: c.lng ?? c.longitude ?? c.lon,
            province: c.province,
            address: c.address,
            location: c.province,
            title: c.title,
            name: c.name,
          });
          return {
          id: c.user_id || c.id,
          name: c.name,
          title: c.title || 'บุคลากรทางการแพทย์',
          category: c.category || 'การแพทย์',
          province: coords.province || c.province || 'กรุงเทพมหานคร',
          address: c.address || '',
          salary: c.salary ? (c.salary.toLocaleString() + ' บาท') : 'ตามตกลง',
          salaryRange: c.salary ? (c.salary.toLocaleString() + ' บาท') : 'ตามตกลง',
          experience: c.experience || '1 ปี',
          age: c.age || '',
          updatedDate: c.updatedDate || 'วันนี้',
          status: c.status || 'เปิดรับงานอยู่ 100%',
          statusBadge: c.statusBadge || 'พร้อมเริ่มงาน',
          verified: Boolean(c.verified),
          avatar: (c.avatar && String(c.avatar).trim() !== '') ? c.avatar : '',
          lat: coords.lat,
          lng: coords.lng,
          phone: c.phone,
          email: c.email,
          lineId: c.lineId,
          linkedin: '',
          resumeFile: c.resumeFile || 'Resume.pdf',
          workHistory: Array.isArray(c.workHistory) ? c.workHistory : [],
          education: Array.isArray(c.education) ? c.education : [],
          skills: Array.isArray(c.skills) ? c.skills : []
        };
        });
        setRawCandidates(cands);
      }
    } catch (err) {
      console.error('[JobSearch] Fetch data failed:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLiveJobData();
  }, [isShopLoggedIn, app_hostname]);

  const handleOpenMapModal = (coords = null) => {
    if (coords && Array.isArray(coords) && coords.length === 2) {
      setMapInitialCoords(coords);
    } else {
      setMapInitialCoords(null);
    }
    setShowMapModal(true);
  };

  const triggerToast = (msg) => {
    setToastMessage(msg);
    setTimeout(() => {
      setToastMessage('');
    }, 3500);
  };

  const handleResetFilters = () => {
    setSelectedCategory('ทั้งหมด');
    setSelectedExp('ทั้งหมด');
    setSelectedSalary('ทั้งหมด');
    setSelectedStatus('ทั้งหมด');
    setSelectedProvince('ทั้งหมด');
    setSearchTerm('');
    setLocationTerm('');
    triggerToast('รีเซ็ตตัวกรองทั้งหมดแล้ว');
  };

  const hasActiveFilters = selectedCategory !== 'ทั้งหมด' || selectedExp !== 'ทั้งหมด' || selectedSalary !== 'ทั้งหมด' || selectedStatus !== 'ทั้งหมด' || selectedProvince !== 'ทั้งหมด' || searchTerm || locationTerm;

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const mode = searchParams.get('mode');
    const candidateId = searchParams.get('candidateId');
    if (mode === 'candidates') {
      setActiveTab('candidates');
    } else {
      setActiveTab('jobs');
    }

    if (candidateId) {
      const candidate = rawCandidates.find(c => String(c.id) === String(candidateId));
      if (candidate) setSelectedCandidate(candidate);
    }
  }, [location, rawCandidates]);

  // Real Filtering Logic for Candidates
  const filteredCandidates = rawCandidates.filter(c => {
    const matchCategory = matchesCategory(c.category, selectedCategory);
    const matchSearch = !searchTerm || includesSafe(c.name, searchTerm) || includesSafe(c.title, searchTerm) || includesSafe(c.category, searchTerm);
    const matchLocation = !locationTerm || includesSafe(c.province, locationTerm);
    const matchProvince = selectedProvince === 'ทั้งหมด' || includesSafe(c.province, selectedProvince);
    const matchStatus = selectedStatus === 'ทั้งหมด' || includesSafe(c.status, selectedStatus) || includesSafe(c.statusBadge, selectedStatus);
    const matchExp = matchesExperienceFilter(c.experience, selectedExp);
    const matchSalary = matchesSalaryRange(c.salaryRange || c.salary, selectedSalary);

    return matchCategory && matchSearch && matchLocation && matchProvince && matchStatus && matchExp && matchSalary;
  });

  // Real Filtering Logic for Jobs
  const filteredJobs = rawJobs.filter(j => {
    const matchCategory = matchesCategory(j.category, selectedCategory);
    const matchSearch = !searchTerm || includesSafe(j.title, searchTerm) || includesSafe(j.company, searchTerm);
    const matchLocation = !locationTerm || includesSafe(j.location, locationTerm);
    const matchProvince = selectedProvince === 'ทั้งหมด' || includesSafe(j.location, selectedProvince);
    const matchSalary = matchesSalaryRange(j.salary, selectedSalary);
    
    let matchRadius = true;
    if (selectedRadius !== 'ทั้งหมด' && userLocation && j.lat && j.lng) {
      const dist = calculateDistanceKm(userLocation.lat, userLocation.lng, j.lat, j.lng);
      matchRadius = dist <= Number(selectedRadius);
    } else if (selectedRadius !== 'ทั้งหมด' && userLocation && (!j.lat || !j.lng)) {
      matchRadius = false; // Exclude jobs without coords if a radius is set
    }

    return matchCategory && matchSearch && matchLocation && matchProvince && matchSalary && matchRadius;
  });

  // Real Sorting Logic for Candidates
  const sortedCandidates = [...filteredCandidates].sort((a, b) => {
    if (sortBy === 'exp_desc') {
      const expA = parseExperienceYears(a.experience);
      const expB = parseExperienceYears(b.experience);
      return (expB ?? -1) - (expA ?? -1);
    }
    if (sortBy === 'salary_desc') {
      const salA = Math.max(...parseSalaryNumbers(a.salaryRange || a.salary), 0);
      const salB = Math.max(...parseSalaryNumbers(b.salaryRange || b.salary), 0);
      return salB - salA;
    }
    if (sortBy === 'salary_asc') {
      const salA = Math.min(...parseSalaryNumbers(a.salaryRange || a.salary), 999999);
      const salB = Math.min(...parseSalaryNumbers(b.salaryRange || b.salary), 999999);
      return salA - salB;
    }
    return String(b.id || '').localeCompare(String(a.id || ''));
  });

  // Real Sorting Logic for Jobs
  const sortedJobs = [...filteredJobs].sort((a, b) => {
    if (sortBy === 'salary_desc') {
      const salA = Math.max(...parseSalaryNumbers(a.salary), 0);
      const salB = Math.max(...parseSalaryNumbers(b.salary), 0);
      return salB - salA;
    }
    if (sortBy === 'salary_asc') {
      const salA = Math.min(...parseSalaryNumbers(a.salary), 999999);
      const salB = Math.min(...parseSalaryNumbers(b.salary), 999999);
      return salA - salB;
    }
    return String(b.id || '').localeCompare(String(a.id || ''));
  });

  const totalJobPages = Math.max(1, Math.ceil(sortedJobs.length / JOBS_PER_PAGE));
  const currentJobsPage = Math.min(jobsPage, totalJobPages);
  const pagedJobs = sortedJobs.slice(
    (currentJobsPage - 1) * JOBS_PER_PAGE,
    currentJobsPage * JOBS_PER_PAGE,
  );

  useEffect(() => {
    setJobsPage(1);
  }, [searchTerm, locationTerm, selectedCategory, selectedSalary, selectedProvince, selectedRadius, sortBy, userLocation]);

  const handleSearchSubmit = (e) => {
    if (e) e.preventDefault();
    triggerToast(activeTab === 'candidates' ? `พบผู้หางาน ${filteredCandidates.length} คน` : `พบตำแหน่งงาน ${filteredJobs.length} ตำแหน่ง`);
  };

  const handleDownloadResume = (candidate) => {
    triggerToast(`กำลังดาวน์โหลดไฟล์เรซูเม่ ${candidate.resumeFile || 'Resume.pdf'}`);
  };

  const handlePrintResume = () => {
    window.print();
  };

  const toggleDropdown = (name) => {
    setOpenDropdown(prev => prev === name ? null : name);
  };

  return (
    <div className='job-board-container' onClick={() => setOpenDropdown(null)}>
      {/* Toast Notification */}
      {toastMessage && (
        <div className='job-alert-toast-floating'>
          <i className='mdi mdi-information-outline'></i>
          <span>{toastMessage}</span>
        </div>
      )}

      {activeTab === 'candidates' && !isShopLoggedIn && (
        <section className='job-locked-section' style={{ textAlign: 'center', padding: '80px 20px', minHeight: '60vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: colors.white, padding: '40px 32px', borderRadius: '16px', maxWidth: '540px', width: '100%', boxShadow: '0 10px 35px rgba(0,0,0,0.06)', border: '1px solid #e2e8f0' }}>
            <div style={{ width: '72px', height: '72px', borderRadius: '50%', background: colors.blue50, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px', color: colors.blue600, fontSize: '32px' }}>
              <i className='mdi mdi-shield-lock-outline'></i>
            </div>
            <h2 style={{ fontSize: '1.4rem', fontWeight: 700, color: colors.slate800, marginBottom: '10px' }}>
              พื้นที่เฉพาะสำหรับบัญชีร้านค้า
            </h2>
            <p style={{ color: colors.slate500, fontSize: '0.95rem', lineHeight: 1.6, marginBottom: '24px' }}>
              การค้นหาและเข้าถึงข้อมูลผู้สมัครงานสายสุขภาพ สงวนสิทธิ์เฉพาะร้านค้าและสถานประกอบการ (account_shop) ที่ได้รับการรับรองในระบบ Meya เท่านั้น
            </p>
            <button
              type='button'
              className='btn-action-primary'
              style={{ width: '100%', padding: '12px 24px', fontSize: '1rem', borderRadius: '8px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}
              onClick={() => {
                if (typeof open_signin === 'function') {
                  open_signin();
                } else {
                  navigate('/login');
                }
              }}
            >
              <i className='mdi mdi-login'></i> เข้าสู่ระบบร้านค้า (Shop Login)
            </button>
          </div>
        </section>
      )}

      {activeTab === 'candidates' && isShopLoggedIn && (
        <>
          {/* Hero Section for Candidates */}
          <section className='job-hero-new candidate-hero'>
            <div className='hero-titles'>
              <h1>ค้นหาคนทำงานบน <span>JobsMEYA</span></h1>
              <p>ค้นหาโปรไฟล์บุคลากรทางการแพทย์ แพทย์ พยาบาล เภสัชกร ที่เปิดการมองเห็นเป็นสาธารณะ</p>
            </div>
            <form onSubmit={handleSearchSubmit} className='search-box-new'>
              <div className='search-input-field search-field-keyword'>
                <i className='mdi mdi-account-search-outline'></i>
                <input
                  type='text'
                  placeholder='ค้นหาตำแหน่งงาน, สายงาน, ทักษะ หรือชื่อคนทำงาน...'
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <div className='input-divider'></div>
              <div className='search-input-field search-field-location'>
                <i className='mdi mdi-map-marker-outline'></i>
                <input
                  type='text'
                  placeholder='จังหวัด'
                  value={locationTerm}
                  onChange={(e) => setLocationTerm(e.target.value)}
                />
              </div>
              <button type='submit' className='btn-search-new'>ค้นหา</button>
            </form>

            {/* Interactive Filter Chips Row */}
            <div className='filter-chips-row' onClick={(e) => e.stopPropagation()}>
              {/* 1. วิชาชีพ Dropdown */}
              <div className='filter-chip-wrapper'>
                <button
                  type='button'
                  className={`filter-chip ${selectedCategory !== 'ทั้งหมด' ? 'selected' : ''}`}
                  onClick={() => toggleDropdown('category')}
                >
                  <i className='mdi mdi-account-tie'></i> {selectedCategory === 'ทั้งหมด' ? 'วิชาชีพ' : `วิชาชีพ: ${selectedCategory}`} <i className='mdi mdi-chevron-down'></i>
                </button>
                {openDropdown === 'category' && (
                  <div className='filter-dropdown-menu'>
                    {categoryFilterOptions.map(cat => (
                      <div
                        key={cat}
                        className={`filter-dropdown-item ${selectedCategory === cat ? 'selected' : ''}`}
                        onClick={() => {
                          setSelectedCategory(cat);
                          setOpenDropdown(null);
                          triggerToast(`กรองวิชาชีพ: ${cat}`);
                        }}
                      >
                        <span>{cat}</span>
                        {selectedCategory === cat && <i className='mdi mdi-check text-primary'></i>}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* 2. ประสบการณ์ Dropdown */}
              <div className='filter-chip-wrapper'>
                <button
                  type='button'
                  className={`filter-chip ${selectedExp !== 'ทั้งหมด' ? 'selected' : ''}`}
                  onClick={() => toggleDropdown('experience')}
                >
                  <i className='mdi mdi-briefcase-outline'></i> {selectedExp === 'ทั้งหมด' ? 'ประสบการณ์' : `ประสบการณ์: ${selectedExp}`} <i className='mdi mdi-chevron-down'></i>
                </button>
                {openDropdown === 'experience' && (
                  <div className='filter-dropdown-menu'>
                    {['ทั้งหมด', 'จบใหม่ / < 1 ปี', '1 - 3 ปี', '3 - 5 ปี', '5 ปีขึ้นไป'].map(exp => (
                      <div
                        key={exp}
                        className={`filter-dropdown-item ${selectedExp === exp ? 'selected' : ''}`}
                        onClick={() => {
                          setSelectedExp(exp);
                          setOpenDropdown(null);
                          triggerToast(`กรองประสบการณ์: ${exp}`);
                        }}
                      >
                        <span>{exp}</span>
                        {selectedExp === exp && <i className='mdi mdi-check text-primary'></i>}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* 3. เงินเดือน Dropdown */}
              <div className='filter-chip-wrapper'>
                <button
                  type='button'
                  className={`filter-chip ${selectedSalary !== 'ทั้งหมด' ? 'selected' : ''}`}
                  onClick={() => toggleDropdown('salary')}
                >
                  <i className='mdi mdi-currency-usd'></i> {selectedSalary === 'ทั้งหมด' ? 'เงินเดือน' : `เงินเดือน: ${selectedSalary}`} <i className='mdi mdi-chevron-down'></i>
                </button>
                {openDropdown === 'salary' && (
                  <div className='filter-dropdown-menu'>
                    {['ทั้งหมด', '15,000 - 30,000 บาท', '30,000 - 50,000 บาท', '50,000 - 100,000 บาท', '100,000+ บาท'].map(sal => (
                      <div
                        key={sal}
                        className={`filter-dropdown-item ${selectedSalary === sal ? 'selected' : ''}`}
                        onClick={() => {
                          setSelectedSalary(sal);
                          setOpenDropdown(null);
                          triggerToast(`กรองช่วงเงินเดือน: ${sal}`);
                        }}
                      >
                        <span>{sal}</span>
                        {selectedSalary === sal && <i className='mdi mdi-check text-primary'></i>}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* 4. สถานะการทำงาน Dropdown */}
              <div className='filter-chip-wrapper'>
                <button
                  type='button'
                  className={`filter-chip ${selectedStatus !== 'ทั้งหมด' ? 'selected' : ''}`}
                  onClick={() => toggleDropdown('status')}
                >
                  <i className='mdi mdi-check-circle-outline'></i> {selectedStatus === 'ทั้งหมด' ? 'สถานะการทำงาน' : `สถานะ: ${selectedStatus}`} <i className='mdi mdi-chevron-down'></i>
                </button>
                {openDropdown === 'status' && (
                  <div className='filter-dropdown-menu'>
                    {['ทั้งหมด', 'พร้อมเริ่มงาน', 'เปิดรับงานอยู่ 100%', 'สนใจพิจารณาข้อเสนอ'].map(st => (
                      <div
                        key={st}
                        className={`filter-dropdown-item ${selectedStatus === st ? 'selected' : ''}`}
                        onClick={() => {
                          setSelectedStatus(st);
                          setOpenDropdown(null);
                          triggerToast(`กรองสถานะ: ${st}`);
                        }}
                      >
                        <span>{st}</span>
                        {selectedStatus === st && <i className='mdi mdi-check text-primary'></i>}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* 5. จังหวัด Dropdown */}
              <div className='filter-chip-wrapper'>
                <button
                  type='button'
                  className={`filter-chip ${selectedProvince !== 'ทั้งหมด' ? 'selected' : ''}`}
                  onClick={() => toggleDropdown('province')}
                >
                  <i className='mdi mdi-map-marker-distance'></i> {selectedProvince === 'ทั้งหมด' ? 'จังหวัด' : `จังหวัด: ${selectedProvince}`} <i className='mdi mdi-chevron-down'></i>
                </button>
                {openDropdown === 'province' && (
                  <div className='filter-dropdown-menu'>
                    {['ทั้งหมด', ...THAI_PROVINCES].map(prov => (
                      <div
                        key={prov}
                        className={`filter-dropdown-item ${selectedProvince === prov ? 'selected' : ''}`}
                        onClick={() => {
                          setSelectedProvince(prov);
                          setOpenDropdown(null);
                          triggerToast(`กรองจังหวัด: ${prov}`);
                        }}
                      >
                        <span>{prov}</span>
                        {selectedProvince === prov && <i className='mdi mdi-check text-primary'></i>}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* 6. รัศมีค้นหา Dropdown (Near Me) */}
              <div className='filter-chip-wrapper'>
                <button
                  type='button'
                  className={`filter-chip ${selectedRadius !== 'ทั้งหมด' ? 'selected' : ''}`}
                  onClick={() => toggleDropdown('radius')}
                >
                  <i className='mdi mdi-map-marker-radius'></i> {selectedRadius === 'ทั้งหมด' ? 'ค้นหาใกล้ฉัน' : `ระยะ: ${selectedRadius} กม.`} <i className='mdi mdi-chevron-down'></i>
                </button>
                {openDropdown === 'radius' && (
                  <div className='filter-dropdown-menu' style={{ minWidth: 240 }}>
                    <div className='filter-dropdown-item' style={{ background: '#f0f9ff', color: '#0284c7', padding: '10px', fontWeight: 'bold' }} onClick={() => {
                        if (!userLocation) {
                          setToastMessage('กำลังขอตำแหน่งที่ตั้งของคุณ...');
                          navigator.geolocation.getCurrentPosition(
                            (pos) => {
                              setUserLocation({ lat: pos.coords.latitude, lng: pos.coords.longitude });
                              if (selectedRadius === 'ทั้งหมด') setSelectedRadius('10');
                              setToastMessage('ดึงตำแหน่งสำเร็จ! กำลังค้นหางานใกล้เคียง');
                              setOpenDropdown(null);
                            },
                            (err) => setToastMessage('ไม่สามารถดึงตำแหน่งได้ กรุณาเปิดใช้งาน GPS')
                          );
                        } else {
                          setUserLocation(null);
                          setSelectedRadius('ทั้งหมด');
                          setToastMessage('ปิดการค้นหาใกล้ฉันแล้ว');
                          setOpenDropdown(null);
                        }
                    }}>
                      <i className='mdi mdi-crosshairs-gps'></i> {userLocation ? 'ปิดพิกัด (ปิดค้นหาใกล้ฉัน)' : 'เปิดค้นหาพิกัดปัจจุบัน (GPS)'}
                    </div>
                    {userLocation && ['ทั้งหมด', '5', '10', '20', '50'].map(rad => (
                      <div
                        key={rad}
                        className={`filter-dropdown-item ${selectedRadius === rad ? 'selected' : ''}`}
                        onClick={() => {
                          setSelectedRadius(rad);
                          setOpenDropdown(null);
                          setToastMessage(rad === 'ทั้งหมด' ? 'ไม่จำกัดระยะ' : `กรองรัศมี: ${rad} กม.`);
                        }}
                      >
                        <span>{rad === 'ทั้งหมด' ? 'ไม่จำกัดระยะ (ทั่วประเทศ)' : `ภายในรัศมี ${rad} กิโลเมตร`}</span>
                        {selectedRadius === rad && <i className='mdi mdi-check text-primary'></i>}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Reset Filter Button */}
              {hasActiveFilters && (
                <button
                  type='button'
                  className='btn-reset-filters'
                  onClick={handleResetFilters}
                  title='ล้างตัวกรองทั้งหมด'
                >
                  <i className='mdi mdi-refresh'></i> ล้างตัวกรอง
                </button>
              )}
            </div>
          </section>

          {/* Main Layout for Candidates */}
          <section className='job-main-layout'>
            <div className='mobile-filter-toggle-row'>
              <button
                type='button'
                className={`btn-mobile-filter-toggle ${showMobileFilters ? 'active' : ''}`}
                onClick={() => setShowMobileFilters((prev) => !prev)}
              >
                <i className='mdi mdi-filter-variant'></i>
                {showMobileFilters ? 'ซ่อนตัวกรอง' : 'ตัวกรอง'}
                {hasActiveFilters ? ' •' : ''}
              </button>
            </div>
            {/* Sidebar Left: Filters */}
            <div className={`sidebar-left ${showMobileFilters ? 'mobile-open' : ''}`}>
              {/* Live Interactive Map Widget */}
              <JobSidebarMapWidget
                mode='candidates'
                items={filteredCandidates}
                onOpenFullMap={handleOpenMapModal}
                onToast={triggerToast}
                onSelectCandidate={(cand) => setSelectedCandidate(cand)}
              />

              <div className='sidebar-box'>
                <h3>สายงาน / วิชาชีพ</h3>
                <div className='candidate-filter-list'>
                  {categoryFilterOptions.map(cat => (
                    <label key={cat} className={`filter-radio-item ${selectedCategory === cat ? 'active' : ''}`}>
                      <input
                        type='radio'
                        name='candidate_cat'
                        checked={selectedCategory === cat}
                        onChange={() => {
                          setSelectedCategory(cat);
                          triggerToast(`กรองข้อมูลสายงาน: ${cat}`);
                        }}
                      />
                      <span>{cat}</span>
                    </label>
                  ))}
                </div>
              </div>

              <div className='sidebar-box'>
                <h3>เงินเดือนที่คาดหวัง</h3>
                <div className='salary-range-box'>
                  <select
                    value={selectedSalary}
                    onChange={(e) => setSelectedSalary(e.target.value)}
                    className='form-select form-select-sm'
                    style={{ width: '100%', padding: '6px 10px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '13px' }}
                  >
                    <option value='ทั้งหมด'>ทุกช่วงเงินเดือน</option>
                    <option value='15,000 - 30,000 บาท'>15,000 - 30,000 บาท</option>
                    <option value='30,000 - 50,000 บาท'>30,000 - 50,000 บาท</option>
                    <option value='50,000 - 100,000 บาท'>50,000 - 100,000 บาท</option>
                    <option value='100,000+ บาท'>100,000+ บาท</option>
                  </select>
                </div>
              </div>

              <div className='sidebar-box'>
                <h3>ประสบการณ์ทำงาน</h3>
                <div className='checkbox-filter-list'>
                  {[
                    { label: 'ประสบการณ์ทั้งหมด', val: 'ทั้งหมด' },
                    { label: 'จบใหม่ / น้อยกว่า 1 ปี', val: 'จบใหม่ / < 1 ปี' },
                    { label: '1 - 3 ปี', val: '1 - 3 ปี' },
                    { label: '3 - 5 ปี', val: '3 - 5 ปี' },
                    { label: '5 ปีขึ้นไป', val: '5 ปีขึ้นไป' },
                  ].map((item) => (
                    <label key={item.val} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', color: colors.slate600 }}>
                      <input
                        type='radio'
                        name='candidateExpFilter'
                        checked={selectedExp === item.val}
                        onChange={() => setSelectedExp(item.val)}
                      />
                      {item.label}
                    </label>
                  ))}
                </div>
              </div>
            </div>

            {/* Content Right: Candidate Cards Grid */}
            <div className='content-right'>
              <div className='content-header'>
                <span className='job-count'>พบโปรไฟล์ผู้หางาน {filteredCandidates.length} คน</span>
                <div className='sort-box' style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <span>เรียงตาม:</span>
                  <select
                    value={sortBy}
                    onChange={(e) => setSortBy(e.target.value)}
                    style={{
                      border: '1px solid #cbd5e1',
                      borderRadius: '6px',
                      padding: '4px 8px',
                      fontSize: '0.85rem',
                      fontWeight: '600',
                      color: colors.slate800,
                      background: colors.white,
                      cursor: 'pointer',
                      outline: 'none',
                    }}
                  >
                    <option value='latest'>อัปเดตล่าสุด</option>
                    <option value='exp_desc'>ประสบการณ์: มากไปน้อย</option>
                    <option value='salary_desc'>เงินเดือน: มากไปน้อย</option>
                    <option value='salary_asc'>เงินเดือน: น้อยไปมาก</option>
                  </select>
                </div>
              </div>

              <div className='candidate-grid-4'>
                {sortedCandidates.map(candidate => (
                  <div className='candidate-card' key={candidate.id}>
                    <div className='candidate-avatar-wrap'>
                      {candidate.avatar && !candidateImgErrors[candidate.id] ? (
                        <img
                          src={candidate.avatar}
                          alt={candidate.name}
                          className='candidate-avatar-img'
                          onError={() => handleCandidateImgError(candidate.id)}
                        />
                      ) : (
                        <div className='candidate-avatar-placeholder-box'>
                          <div className='candidate-placeholder-circle'>
                            <i className='mdi mdi-account'></i>
                          </div>
                        </div>
                      )}
                      <span className='status-pill-badge'><i className='mdi mdi-check-circle'></i> {candidate.statusBadge}</span>
                    </div>

                    <div className='candidate-card-body'>
                      <div className='candidate-name-row'>
                        <h4>{candidate.name}</h4>
                        {candidate.verified && <i className='mdi mdi-check-decagram text-primary' title='ยืนยันตัวตนแล้ว'></i>}
                      </div>
                      <p className='candidate-title-text'>{candidate.title}</p>

                      <div className='candidate-info-tags'>
                        <span><i className='mdi mdi-map-marker-outline'></i> {candidate.province}</span>
                        <span><i className='mdi mdi-briefcase-outline'></i> ประสบการณ์ {candidate.experience}</span>
                        <span className='salary-tag'><i className='mdi mdi-currency-usd'></i> {candidate.salaryRange}</span>
                      </div>

                      <button
                        className='btn-view-candidate-profile'
                        onClick={() => setSelectedCandidate(candidate)}
                      >
                        ดูโปรไฟล์
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </>
      )}

      {/* ========================================================================= */}
      {/* SCREEN 2: Candidate Profile Details Modal (ดูโปรไฟล์ผู้หางาน)           */}
      {/* ========================================================================= */}
      {selectedCandidate && (
        <div className='candidate-detail-modal-overlay'>
          <div className='candidate-detail-modal-container'>
            <div className='modal-top-bar'>
              <button
                className='btn-back-link'
                onClick={() => setSelectedCandidate(null)}
              >
                <i className='mdi mdi-arrow-left'></i> ย้อนกลับ
              </button>
              <h2>โปรไฟล์ผู้หางาน: {selectedCandidate.name}</h2>
              <button
                className='btn-close-modal'
                onClick={() => setSelectedCandidate(null)}
              >
                &times;
              </button>
            </div>

            <div className='candidate-detail-layout'>
              {/* Left Column: Avatar & Summary */}
              <div className='candidate-summary-left'>
                <div className='candidate-main-photo-card'>
                  {selectedCandidate.avatar && !candidateImgErrors[selectedCandidate.id] ? (
                    <img
                      src={selectedCandidate.avatar}
                      alt={selectedCandidate.name}
                      className='candidate-main-photo'
                      onError={() => handleCandidateImgError(selectedCandidate.id)}
                    />
                  ) : (
                    <div className='candidate-modal-placeholder-circle'>
                      <i className='mdi mdi-account'></i>
                    </div>
                  )}
                  <div className='candidate-name-header'>
                    <h3>{selectedCandidate.name} {selectedCandidate.verified && <i className='mdi mdi-check-decagram text-primary'></i>}</h3>
                    <span className='status-live-pill'><i className='mdi mdi-circle'></i> {selectedCandidate.status}</span>
                  </div>
                  <p className='candidate-sub-title'>{selectedCandidate.title}</p>
                  <p className='verified-text'><i className='mdi mdi-shield-check'></i> ยืนยันตัวตนบุคลากรทางการแพทย์แล้ว</p>
                </div>

                <div className='candidate-contact-box'>
                  <h4>ข้อมูลติดต่อ</h4>
                  <div className='contact-item'><i className='mdi mdi-email-outline'></i> <span>{selectedCandidate.email}</span></div>
                  <div className='contact-item'><i className='mdi mdi-phone-outline'></i> <span>{selectedCandidate.phone}</span></div>
                  <div className='contact-item'><i className='mdi mdi-map-marker-outline'></i> <span>{selectedCandidate.address}</span></div>
                  <div className='contact-item'><i className='mdi mdi-message-text-outline'></i> <span>LINE ID: {selectedCandidate.lineId}</span></div>
                  <div className='contact-item'><i className='mdi mdi-linkedin'></i> <span>{selectedCandidate.linkedin}</span></div>
                </div>

                <div className='candidate-stats-grid'>
                  <div className='stat-box-item'>
                    <span className='stat-label'>ประสบการณ์</span>
                    <strong className='stat-value'>{selectedCandidate.experience}</strong>
                  </div>
                  <div className='stat-box-item'>
                    <span className='stat-label'>เงินเดือนที่ต้องการ</span>
                    <strong className='stat-value'>{selectedCandidate.salary}</strong>
                  </div>
                  <div className='stat-box-item'>
                    <span className='stat-label'>อายุ</span>
                    <strong className='stat-value'>{selectedCandidate.age}</strong>
                  </div>
                  <div className='stat-box-item'>
                    <span className='stat-label'>อัปเดตล่าสุด</span>
                    <strong className='stat-value'>{selectedCandidate.updatedDate}</strong>
                  </div>
                </div>
              </div>

              {/* Right Column: Full Detailed Resume */}
              <div className='candidate-resume-right'>
                {/* Resume Action Banner */}
                <div className='resume-download-banner'>
                  <div className='pdf-file-info'>
                    <i className='mdi mdi-file-pdf-box text-danger' style={{ fontSize: '2.5rem' }}></i>
                    <div>
                      <h5>{selectedCandidate.resumeFile}</h5>
                      <span>เอกสารแนบเรซูเม่ฉบับสมบูรณ์ (PDF)</span>
                    </div>
                  </div>
                  <div className='resume-action-btns'>
                    <button className='btn-action-outline' onClick={() => handleDownloadResume(selectedCandidate)}>
                      <i className='mdi mdi-download'></i> ดาวน์โหลด
                    </button>
                    <button className='btn-action-outline' onClick={handlePrintResume}>
                      <i className='mdi mdi-printer'></i> พิมพ์
                    </button>
                    <button className='btn-action-primary' onClick={() => setShowContactModal(true)}>
                      <i className='mdi mdi-phone'></i> ติดต่อผู้หางาน
                    </button>
                  </div>
                </div>

                {/* Section: Work Experience */}
                <div className='resume-section-card'>
                  <div className='section-title-bar'>
                    <i className='mdi mdi-briefcase-clock-outline'></i>
                    <h4>ประวัติการทำงาน</h4>
                  </div>
                  <div className='timeline-list'>
                    {selectedCandidate.workHistory.map((work, idx) => (
                      <div key={idx} className='timeline-item'>
                        <div className='timeline-dot'></div>
                        <div className='timeline-content'>
                          <div className='timeline-header-row'>
                            <h5>{work.position}</h5>
                            <span className='timeline-period'>{work.period}</span>
                          </div>
                          <p className='company-name-text'>{work.company}</p>
                          <p className='work-detail-desc'>{work.details}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Section: Education */}
                <div className='resume-section-card'>
                  <div className='section-title-bar'>
                    <i className='mdi mdi-school-outline'></i>
                    <h4>ประวัติการศึกษา</h4>
                  </div>
                  <div className='timeline-list'>
                    {selectedCandidate.education.map((edu, idx) => (
                      <div key={idx} className='timeline-item'>
                        <div className='timeline-dot'></div>
                        <div className='timeline-content'>
                          <div className='timeline-header-row'>
                            <h5>{edu.degree}</h5>
                            <span className='timeline-period'>{edu.period}</span>
                          </div>
                          <p className='company-name-text'>{edu.institution}</p>
                          <p className='work-detail-desc'>{edu.gpa}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Section: Skills & Certifications */}
                <div className='resume-section-card'>
                  <div className='section-title-bar'>
                    <i className='mdi mdi-star-outline'></i>
                    <h4>ทักษะและความสามารถ</h4>
                  </div>
                  <div className='skill-badge-wrap'>
                    {selectedCandidate.skills.map((skill, idx) => (
                      <span key={idx} className='skill-tag-badge'>{skill}</span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Map View Modal — employer hiring locations or candidates */}
      {showMapModal && (
        <JobEmployerMap
          mode={activeTab === 'candidates' ? 'candidates' : 'jobs'}
          items={activeTab === 'candidates' ? filteredCandidates : filteredJobs}
          initialUserCoords={mapInitialCoords}
          onClose={() => setShowMapModal(false)}
          onToast={triggerToast}
          onSelectCandidate={(cand) => setSelectedCandidate(cand)}
        />
      )}

      {/* Contact Candidate Modal */}
      {showContactModal && selectedCandidate && (
        <div className='job-auth-modal-overlay' onClick={() => setShowContactModal(false)}>
          <div className='job-auth-container' style={{ maxWidth: '500px' }} onClick={e => e.stopPropagation()}>
            <div className='job-auth-card'>
              <div className='job-auth-header'>
                <div className='job-auth-brand'>ติดต่อผู้หางาน</div>
                <h3>{selectedCandidate.name}</h3>
                <p>{selectedCandidate.title}</p>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', background: colors.slate50, padding: '16px', borderRadius: '10px' }}>
                <div><strong>📞 เบอร์โทรศัพท์:</strong> {selectedCandidate.phone}</div>
                <div><strong>📧 อีเมล:</strong> {selectedCandidate.email}</div>
                <div><strong>💬 LINE ID:</strong> {selectedCandidate.lineId}</div>
              </div>
              <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
                <button
                  className='btn-action-primary'
                  style={{ flex: 1 }}
                  onClick={() => {
                    triggerToast(`กำลังโทรติดต่อ ${selectedCandidate.name} (${selectedCandidate.phone})...`);
                    setShowContactModal(false);
                  }}
                >
                  <i className='mdi mdi-phone'></i> โทรออก
                </button>
                <button
                  className='btn-action-outline'
                  style={{ flex: 1 }}
                  onClick={() => setShowContactModal(false)}
                >
                  ปิด
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ========================================================================= */}
      {/* DEFAULT SCREEN: Job Search (ค้นหาตำแหน่งงาน)                             */}
      {/* ========================================================================= */}
      {activeTab === 'jobs' && (
        <>
          {/* Hero Section */}
          <section className='job-hero-new'>
            <div className='hero-titles'>
              <h1>หางานสายสุขภาพ <span>ที่ใช่</span> สำหรับคุณ</h1>
              <p>รวมตำแหน่งงานแพทย์ พยาบาล เภสัชกร และบุคลากรทางการแพทย์ ทั่วประเทศ</p>
            </div>
            <form onSubmit={handleSearchSubmit} className='search-box-new'>
              <div className='search-input-field search-field-keyword'>
                <i className='mdi mdi-magnify'></i>
                <input
                  type='text'
                  placeholder='ค้นหาตำแหน่งงานที่คุณกำลังมองหาได้เลย (ตำแหน่งงาน, สายงาน, ทักษะ...)'
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <div className='input-divider'></div>
              <div className='search-input-field search-field-location'>
                <i className='mdi mdi-map-marker-outline'></i>
                <input
                  type='text'
                  placeholder='สถานที่ทำงาน'
                  value={locationTerm}
                  onChange={(e) => setLocationTerm(e.target.value)}
                />
              </div>
              <button type='submit' className='btn-search-new'>หางาน</button>
            </form>
            <div className='filter-chips-row' onClick={(e) => e.stopPropagation()}>
              <div className='filter-chips-group'>
              <div className='filter-chip-wrapper'>
                <button
                  type='button'
                  className={`filter-chip ${selectedCategory !== 'ทั้งหมด' ? 'selected' : ''}`}
                  onClick={() => toggleDropdown('category')}
                >
                  <i className='mdi mdi-account-tie'></i> {selectedCategory === 'ทั้งหมด' ? 'วิชาชีพ' : `วิชาชีพ: ${selectedCategory}`} <i className='mdi mdi-chevron-down'></i>
                </button>
                {openDropdown === 'category' && (
                  <div className='filter-dropdown-menu'>
                    {categoryFilterOptions.map(cat => (
                      <div
                        key={cat}
                        className={`filter-dropdown-item ${selectedCategory === cat ? 'selected' : ''}`}
                        onClick={() => {
                          setSelectedCategory(cat);
                          setOpenDropdown(null);
                          triggerToast(`กรองวิชาชีพ: ${cat}`);
                        }}
                      >
                        <span>{cat}</span>
                        {selectedCategory === cat && <i className='mdi mdi-check text-primary'></i>}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div className='filter-chip-wrapper'>
                <button
                  type='button'
                  className={`filter-chip ${selectedProvince !== 'ทั้งหมด' ? 'selected' : ''}`}
                  onClick={() => toggleDropdown('province')}
                >
                  <i className='mdi mdi-map-marker-distance'></i> {selectedProvince === 'ทั้งหมด' ? 'จังหวัด' : `จังหวัด: ${selectedProvince}`} <i className='mdi mdi-chevron-down'></i>
                </button>
                {openDropdown === 'province' && (
                  <div className='filter-dropdown-menu'>
                    {['ทั้งหมด', ...THAI_PROVINCES].map(prov => (
                      <div
                        key={prov}
                        className={`filter-dropdown-item ${selectedProvince === prov ? 'selected' : ''}`}
                        onClick={() => {
                          setSelectedProvince(prov);
                          setOpenDropdown(null);
                          triggerToast(`กรองจังหวัด: ${prov}`);
                        }}
                      >
                        <span>{prov}</span>
                        {selectedProvince === prov && <i className='mdi mdi-check text-primary'></i>}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div className='filter-chip-wrapper'>
                <button
                  type='button'
                  className={`filter-chip ${selectedSalary !== 'ทั้งหมด' ? 'selected' : ''}`}
                  onClick={() => toggleDropdown('salary')}
                >
                  <i className='mdi mdi-currency-usd'></i> {selectedSalary === 'ทั้งหมด' ? 'เงินเดือน' : `เงินเดือน: ${selectedSalary}`} <i className='mdi mdi-chevron-down'></i>
                </button>
                {openDropdown === 'salary' && (
                  <div className='filter-dropdown-menu'>
                    {['ทั้งหมด', '15,000 - 30,000 บาท', '30,000 - 50,000 บาท', '50,000 - 100,000 บาท', '100,000+ บาท'].map(sal => (
                      <div
                        key={sal}
                        className={`filter-dropdown-item ${selectedSalary === sal ? 'selected' : ''}`}
                        onClick={() => {
                          setSelectedSalary(sal);
                          setOpenDropdown(null);
                          triggerToast(`กรองช่วงเงินเดือน: ${sal}`);
                        }}
                      >
                        <span>{sal}</span>
                        {selectedSalary === sal && <i className='mdi mdi-check text-primary'></i>}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {hasActiveFilters && (
                <button
                  type='button'
                  className='btn-reset-filters'
                  onClick={handleResetFilters}
                  title='ล้างตัวกรองทั้งหมด'
                >
                  <i className='mdi mdi-refresh'></i> ล้างตัวกรอง
                </button>
              )}
              </div>
            </div>
          </section>

          {/* Main Layout */}
          <section className='job-main-layout'>
            <div className='mobile-filter-toggle-row'>
              <button
                type='button'
                className={`btn-mobile-filter-toggle ${showMobileFilters ? 'active' : ''}`}
                onClick={() => setShowMobileFilters((prev) => !prev)}
              >
                <i className='mdi mdi-filter-variant'></i>
                {showMobileFilters ? 'ซ่อนตัวกรอง' : 'ตัวกรอง'}
                {hasActiveFilters ? ' •' : ''}
              </button>
              <button
                type='button'
                className='btn-mobile-filter-toggle btn-mobile-map'
                onClick={() => handleOpenMapModal()}
              >
                <i className='mdi mdi-map-marker-radius'></i>
                แผนที่
              </button>
            </div>
            {/* Sidebar Left */}
            <div className={`sidebar-left ${showMobileFilters ? 'mobile-open' : ''}`}>
              {/* Live Interactive Map Widget */}
              <JobSidebarMapWidget
                mode='jobs'
                items={filteredJobs}
                onOpenFullMap={handleOpenMapModal}
                onToast={triggerToast}
              />

              <div className='sidebar-box'>
                <h3>หมวดหมู่วิชาชีพ</h3>
                <ul className='category-list'>
                  {careerCategories.map(cat => (
                    <li key={cat.id} onClick={() => {
                      setSelectedCategory(cat.title);
                      triggerToast(`กรองตำแหน่งงานหมวด: ${cat.title}`);
                    }}>
                      <span><i className={`mdi ${cat.icon}`}></i> {cat.title}</span>
                      <span className='count'>{cat.count}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Sidebar Support / LINE Help Card */}
              <div className='job-sidebar-support-card'>
                <div className='support-icon-badge'>
                  <i className='mdi mdi-headset'></i>
                </div>
                <h4 className='support-card-title'>พบปัญหาการใช้งาน?</h4>
                <p className='support-card-desc'>
                  แจ้งปัญหาหรือสอบถามข้อมูลเพิ่มเติมกับทีมงานมียาได้ทันที
                </p>
                <a
                  href='https://line.me/R/ti/p/@meya'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='btn-line-support'
                >
                  <i className='mdi mdi-chat-processing'></i> ติดต่อ LINE @meya
                </a>
              </div>
            </div>

            {/* Content Right */}
            <div className='content-right'>
              <div className='content-header'>
                <span className='job-count'>
                  พบตำแหน่งงาน {filteredJobs.length} ตำแหน่ง
                  {filteredJobs.length > JOBS_PER_PAGE
                    ? ` (แสดง ${pagedJobs.length} รายการ หน้า ${currentJobsPage}/${totalJobPages})`
                    : ''}
                </span>
                <div className='sort-box' style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <span>เรียงตาม:</span>
                  <select
                    value={sortBy}
                    onChange={(e) => setSortBy(e.target.value)}
                    style={{
                      border: '1px solid #cbd5e1',
                      borderRadius: '6px',
                      padding: '4px 8px',
                      fontSize: '0.85rem',
                      fontWeight: '600',
                      color: colors.slate800,
                      background: colors.white,
                      cursor: 'pointer',
                      outline: 'none',
                    }}
                  >
                    <option value='latest'>ล่าสุด</option>
                    <option value='salary_desc'>เงินเดือน: มากไปน้อย</option>
                    <option value='salary_asc'>เงินเดือน: น้อยไปมาก</option>
                  </select>
                </div>
              </div>

              <div className='job-grid-4'>
                {pagedJobs.map(job => (
                  <div className='job-card-new' key={job.id} onClick={() => navigate(`/jobs/detail/${job.id}`)}>
                    <div className='card-banner'>
                      <img
                        src={job.poster || job.logo}
                        alt='company'
                        onError={(e) => {
                          if (e.target.src !== job.logo) e.target.src = job.logo;
                        }}
                      />
                    </div>
                    <div className='card-body'>
                      <h4 className='job-title-new'>{job.title}</h4>
                      <div className='job-info-row'>
                        <i className='mdi mdi-domain'></i> {job.company}
                      </div>
                      <div className='job-info-row salary-row'>
                        <i className='mdi mdi-alpha-b-circle'></i> {job.salary}
                      </div>
                      <div className='job-info-row'>
                        <i className='mdi mdi-map-marker'></i> {job.location}
                      </div>
                      <div className='job-type-badge'>{job.type}</div>
                    </div>
                    <div className='card-footer'>
                      <span className='time-posted'>{job.posted}</span>
                      <span className='view-details-link'>ดูรายละเอียด &gt;</span>
                    </div>
                  </div>
                ))}
              </div>

              {totalJobPages > 1 && (
                <div className='jobs-pagination'>
                  <button
                    type='button'
                    className='jobs-page-btn'
                    disabled={currentJobsPage <= 1}
                    onClick={() => {
                      setJobsPage((p) => Math.max(1, p - 1));
                      window.scrollTo({ top: 0, behavior: 'smooth' });
                    }}
                  >
                    ‹ ก่อนหน้า
                  </button>
                  {Array.from({ length: totalJobPages }, (_, i) => i + 1).map((pageNum) => (
                    <button
                      key={pageNum}
                      type='button'
                      className={`jobs-page-btn ${pageNum === currentJobsPage ? 'active' : ''}`}
                      onClick={() => {
                        setJobsPage(pageNum);
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                      }}
                    >
                      {pageNum}
                    </button>
                  ))}
                  <button
                    type='button'
                    className='jobs-page-btn'
                    disabled={currentJobsPage >= totalJobPages}
                    onClick={() => {
                      setJobsPage((p) => Math.min(totalJobPages, p + 1));
                      window.scrollTo({ top: 0, behavior: 'smooth' });
                    }}
                  >
                    ถัดไป ›
                  </button>
                </div>
              )}
            </div>
          </section>
        </>
      )}
    </div>
  );
}

export default JobSearch;
